import type { Inbox } from "../../../api/content/reviewCollaborationApi";
import type { ThreadSummary } from "../../../api/threads/threadDecoders";

/** The open change sets the inbox's "Waiting for you" leads into, by the Run it leads into (its review subject). */
export type InboxSubjects = ReadonlyMap<string, ReadonlySet<string>>;

/**
 * The change sets the inbox leads into: each open one the person is asked to decide or was sent back, under the Run whose
 * step decides it (run-frame P3; F108 "The sidebar IS the Inbox"). The person's own open proposals, waiting on others,
 * are a folded shelf, so their Runs stay listed.
 */
export function inboxSubjects(inbox: Inbox): InboxSubjects {
  const byRun = new Map<string, Set<string>>();
  for (const { review } of [...inbox.waitingForMe, ...inbox.sentBackToMe]) {
    const run = review.reviewSubject?.threadId;
    if (run === undefined || review.changeSet.state !== "open") continue;
    byRun.set(run, (byRun.get(run) ?? new Set<string>()).add(review.changeSet.changeSetId));
  }
  return byRun;
}

/**
 * Whether the inbox's row is this Run's entrance now: this Run's open person step decides a change set the inbox lists
 * for it (Sol r1 to r3, R1). The change set is the review's identity; a step key isn't, as another Workflow may use the
 * same key. The Run is part of it: a fork made at the open review keeps the request, but the inbox leads into the Run it
 * forked from. A Run that left the review, or an inbox read from before the step was decided, keeps its own row.
 */
export function waitsOnTheInbox(summary: ThreadSummary, subjects: InboxSubjects): boolean {
  const changeSet = summary.projection.open_human_step?.change_set_id;
  return changeSet != null && (subjects.get(summary.threadId)?.has(changeSet) ?? false);
}
